import { useResponsive } from '../../../hooks/useResponsive';
import FooterDesktop from './FooterDesktop';
import FooterMobile from './FooterMobile';
import { useFooter } from './useFooter';

const Footer = () => {
  const breakpointIndex = useResponsive([768]);
  const props = useFooter();

  if (breakpointIndex === 0) {
    return <FooterMobile {...props} />;
  }
  return <FooterDesktop {...props} />;
};

export default Footer;
